import { useEffect, useState } from "react";
import { userWithLeads } from "../apiServices/adminWork.services";

const useUsersWithLeads = (params = {}) => {

  const [users,setUsers] = useState([]);
  const [count,setCount] = useState(0);
  const [loading,setLoading] = useState(false);

  const fetchUsers = async () => {
    try {

      setLoading(true);

      const res = await userWithLeads(params);

      setUsers(res?.data?.users || []);
      setCount(res?.data?.count || 0);

    } catch (err) {

      console.error(err);

    } finally {

      setLoading(false);

    }
  };

  useEffect(() => {

    const delay = setTimeout(() => {
      fetchUsers();
    },400);

    return () => clearTimeout(delay);

  },[JSON.stringify(params)]);

  return { users, count, loading, fetchUsers, };
};

export default useUsersWithLeads;